import React from 'react';

const Skill = () => {
    return (
        <div className="hero-img4">
            <div className="heading">
                <h1>Skills</h1>
                <p>
                    As an undergraduate student, I have cultivated a versatile skill set
                    through coursework, projects, and practical experiences. These
                    include robust analytical and research abilities, sharp critical
                    thinking skills, and effective communication aptitude. I have also
                    developed technical proficiency in programming languages and design
                    tools relevant to my field of study. Overall, my undergraduate journey
                    has equipped me with a valuable range of skills for future academic
                    and professional endeavors.
                </p>
                <br></br>
                <p style={{ color: "#a0a067" }}>C (Programming Language)</p><progress value="90" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>React</p><progress value="70" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>HTML</p><progress value="95" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>CSS</p><progress value="75" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>Java</p><progress value="50" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>MongoDB</p><progress value="80" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>Figma</p><progress value="85" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>
                <p style={{ color: "#a0a067" }}>MYSQL</p><progress value="80" max="100" style={{
                    height: '18%',
                    width: '25%',

                }} ></progress>

            </div>
        </div>
    );
};

export default Skill;
